module.exports = __webpack_public_path__ + "img/hero-sm-2x.4841573.webp";